function cleanPhoneNumber(phone) {
    let cleanedPhone = phone.replace('+', '');

    return cleanedPhone.startsWith('0') ? '62' + cleanedPhone.slice(1) : cleanedPhone;
}

export default cleanPhoneNumber;